import { appendSerpBanner } from './appendSerpBanner'

const run = () => {
  // Add GTM helpers here
  global.gtmHelpers = { appendSerpBanner }

  // Run whatever code is needed here
  // ...
}

run()
